module.exports = __webpack_public_path__ + "img/DiNapoli-bg-m.69373e05.png";